function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _isObjectEmpty = function _isObjectEmpty(obj) {
  // Could probably be simplified to: return Object.keys(obj).length === 0
  for (var prop in obj) {
    if (obj[prop] !== '') return false;
  }
  return true;
};
export var isEmpty = function isEmpty(val) {
  if (val === null || val === undefined) return true;
  return typeof val === 'string' ? !val.trim().length : _typeof(val) === 'object' ? _isObjectEmpty(val) : typeof val === 'boolean' || typeof val === 'number' && val > -1 ? false : true;
};
export var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};